<template>
  <div class="searchs">
    <div class="banner">
      <div class="searchbox">
        <p class="searchtitle">探索您需要的内容！</p>
        <div style="display: flex">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="searchvalue"
            style="border-radius: 4px 0px 0 4px"
          >
          </el-input>
          <el-button
            style="
              width: 3.65vw;
              height: 40px;
              border-radius: 0px 4px 4px 0;
              color: #1961ac;
              border: 0;
            "
            @click="searchclick"
            >搜索</el-button
          >
        </div>
      </div>
    </div>
    <div class="searchcontent">
      <p class="restotal" v-if="slist.length > 0">
        为你找到“{{ searchvalue }}”相关结果共{{ slist.length }}条
      </p>
      <div class="searchtotal" v-if="slist.length > 0">
        <div
          class="searchsingle"
          v-for="(i, j) in slist"
          @click="checkinfo(i, j)"
        >
          <div class="spath">
            <span
              v-for="(k, l) in i.path"
              :style="{
                color:
                  l == i.path.length
                    ? 'color: #06192D;'
                    : 'color: rgba(6, 25, 45, 0.68);',
              }"
              >{{ k }} <span v-if="l < i.path.length - 1">>&nbsp;</span>
            </span>
          </div>
          <div class="stitle" style="font-size: 1.25vw; margin-bottom: 0.42vw">
            {{ i.title }}
          </div>
          <div class="scontent">{{ i.summary }}</div>
          <div class="stime">最后更新于{{ i.updateTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchvalue: "",
      slist: [],
    };
  },
  methods: {
    checkinfo(e) {
      let data = {
        category: e.category,
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/news/info",
        query: data,
      });
    },
    async searchclick() {
      let data = {
        keyWords: this.searchvalue,
        current: 1,
        size: 10,
      };
      if (!data.keyWords) {
        console.log("请输入搜索内容");
        return;
      } else {
        let res = await this.$http.searchall(data);
        if (res.code == 200) {
          this.slist = res.data;
          for (let i of this.slist) {
            i.path = i.category.split("/");
          }
          console.log(this.slist);
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.searchs {
  .searchcontent {
    .searchtotal {
      .searchsingle {
        .stime {
          color: rgba(6, 25, 45, 0.68);
          font-size: 0.63vw;
        }
        .scontent {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          min-height: 3.13vw;
          /* 显示的最大行数 */
          overflow: hidden;
          margin-bottom: 0.52vw;
        }
        .spath {
          margin-bottom: 0.42vw;
        }
        width: 100%;
        height: 8.33vw;
        display: flex;
        flex-direction: column;
        margin-bottom: 1.56vw;
      }
      width: 100%;
      background: #fff;
      border-radius: 0.21vw;
      box-shadow: 0px 4px 10px 0px rgba(6, 25, 45, 0.16);
      padding: 1.04vw 1.56vw;
    }
    .restotal {
      font-size: 0.73vw;
      color: rgba(6, 25, 45, 0.68);
      margin-bottom: 1.04vw;
    }
    width: 100%;
    padding: 4.17vw 21.88vw 11.98vw 21.88vw;
  }
  .banner {
    .searchbox {
      .searchtitle {
        font-size: 1.46vw;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        margin-bottom: 1.56vw;
      }
      width: 35.42vw;
      height: 6.41vw;
    }
    width: 100%;
    height: 26.04vw;
    background: url("../assets/image/bannersearch.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  width: 100%;
  height: 100%;
  background: rgba(240, 242, 246, 1);
}
::v-deep.el-input--prefix .el-input__inner {
  padding-left: 1.56vw !important;
  border-radius: 4px 0 0 4px;
}
</style>
